import { MobXProviderContext } from 'mobx-react';
import { ContactModelBase } from 'Models/ContactModel';
import { ContactModelV2 } from 'Models/ContactModelV2';
import React from 'react';
import { RootStoreProps } from 'Stores/RootStore.types';

export const useReactiveContact = (
  contact?: ContactModelV2 | ContactModelBase
): ContactModelV2 | ContactModelBase | null => {
  const { person: personStore } = React.useContext(
    MobXProviderContext
  ) as RootStoreProps;

  // Trigger loading when contact changes
  React.useEffect(() => {
    if (contact instanceof ContactModelV2 && contact.sourceId) {
      void personStore.loadPersonByIdGetIfMissingGet(contact.sourceId);
    }
  }, [contact, personStore]);

  if (!contact) {
    return null;
  }

  // If it's a ContactModelV2 with a sourceId, get it reactively from the store
  if (contact instanceof ContactModelV2 && contact.sourceId) {
    const reactiveContact = personStore.selectPersonValueById(
      Number(contact.sourceId)
    );
    return reactiveContact || contact;
  }

  // For ContactModelBase (unsaved contacts), return as-is
  return contact;
};
